var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block"},[(_vm.live)?_c('span',[_vm._v(_vm._s(_vm._f("format")(_vm.tShow)))]):_c('span',[_vm._v(_vm._s(_vm._f("format")(_vm.time)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }